import { MonitorShimmerIcon } from './MonitorShimmerIcon';

/**
 * author: kevin-hens
 * id E02B1C8D-DA14-4AF2-8EB3-397AD9DAF1AB
 * name monitor-shimmer
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/monitor-shimmer.svg
 * tags
 * - Device / Tech 
 */
export const MonitorCleanIcon = MonitorShimmerIcon;
export default MonitorCleanIcon